import AppContext from "PFApp/app_context";
import { usePusherEvent } from "PFCore/base/pusher";
import { useCustomValuesImports } from "PFCore/hooks/queries/admin/custom_values_imports/use_custom_values_imports";
import { useCustomValuesImportsInvalidate } from "PFCore/hooks/queries/admin/custom_values_imports/use_custom_values_imports_invalidate";
import { CustomValuesImportsParams } from "PFCore/services/admin/imports/fetch_custom_values_imports";
import { useContext } from "react";

import { useSkillsCustomTypeId } from "../../../../utils/use_skills_custom_type";

export const useImportsHistory = (params?: CustomValuesImportsParams) => {
  const typeId = useSkillsCustomTypeId();
  const query = useCustomValuesImports(typeId, params);
  const { invalidate } = useCustomValuesImportsInvalidate();
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  usePusherEvent(`private-profile-${currentProfile.id}`, "custom_value_import_processing_finished", () => {
    invalidate();
  });

  return {
    imports: query.data?.entries,
    counter: query.data?.meta.total,
    totalPages: query.data?.meta.totalPages || 1,
    ...query
  };
};
